"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var dealStorageService_1 = require("../../../../../../common/service/dealStorageService");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var react_1 = require("react");
var Routes_1 = require("../../../../common/enum/Routes");
var collectedFilters_1 = require("../../../../common/service/collectedFilters");
var react_router_1 = require("react-router");
var useDealData = function () {
    var history = react_router_1.useHistory();
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var token = collectedFilters_1.default().filters.token;
    var dealStorage = dealStorageService_1.default.getDeal(dimensions);
    var _a = useCheckoutContext_1.default(), deal = _a.deal, loading = _a.loading, error = _a.error;
    var dealData = loading || !deal ? dealStorage : deal;
    var redirectUnavailableDeal = react_1.useCallback(function () { return history.replace(Routes_1.Routes.DEAL_UNAVAILABLE, {}); }, []);
    react_1.useEffect(function () {
        if ((deal || token) && error) {
            redirectUnavailableDeal();
        }
    }, [loading, token, deal, error]);
    return { dealData: dealData, error: error, loading: loading };
};
exports.default = useDealData;
